import { Ng2StateDeclaration } from '@uirouter/angular';

export const emads: Ng2StateDeclaration = {
    name: 'emads.**',
    url: '/emads',
    loadChildren: () => import(/* webpackChunkName: "emads.module" */ './root/emads.root.module').then(m => m.EMAdsRootModule),
};